<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div :class="blur ? 'blur-lg' : '' " class="fixed h-screen w-screen bg-[url('../assets/background/bathroom.jpg')] bg-cover bg-center bg-no-repeat">
        <div class="flex h-full">            
            <div class="h-full w-1/6">                
                <div class="flex flex-col relative p-5 gap-10">
                    <router-link :to="`/checkpoint`">
                        <div class="bg-white rounded-lg shadow-lg shadow-slate-500 w-fit p-2">
                            <img class="w-10" src="../assets/icon/icon-home.png" alt="home">
                        </div>
                    </router-link>
                    <div class="xl:mt-48 lg:mt-48 md:mt-10 sm:mt-10">
                        <img class="w-[600px] absolute" src="../assets/avatar/avatar-flip.png" alt="avatar">
                    </div>
                </div>
            </div>

            <div class="h-full flex gap-2 flex-col w-4/6 justify-center items-center">           
                <div class="p-4 w-full gap-x-2 flex justify-center items-center bg-transparent shadow-xl rounded-lg py-4">
                    <p class="xl:text-6xl lg:text-6xl md:text-4xl sm:text-4xl">หาของอาบน้ำกัน</p>                    
                    <Sound :checkpoint='2' :autoplay='false'/>
                </div>                                       
                <div class="rounded-lg grid grid-cols-3 gap-4 p-4 border bg-red-50">                              
                    <div v-for="item in levels[$store.state.level]" :key="item">
                        <div class="flex flex-col border-orange-300 border-4 hover:ring-8 rounded-lg px-4" @click="checked($store.state.level+`${item.id}`, item.check, $store.state.level)">
                            <div class="flex justify-end p-2">
                                <input type="checkbox" :id="$store.state.level+item.id" class="h-8 w-8 border rounded bg-lime-500"/>
                            </div>
                            <div class="flex justify-center items-center">
                                <img class="xl:w-48 lg:w-48 md:w-14 sm:w-14" :src="item.url" :alt="item.name">
                            </div>
                        </div>
                    </div>
                </div>                                                    
            </div>

            <div class="flex flex-col-reverse items-center pb-20 h-screen w-1/6" @click="checkAnswer($store.state.level)">
                <div class="flex py-2 w-full mr-10 mb-2 justify-center border border-gray-700 rounded-lg shadow-lg shadow-orange-500 bg-indigo-500 hover:ring-4 hover:ring-indigo-400 active:animate-bounce">
                    <img class="w-20" src="../assets/materials/checked.png" alt="checked">
                </div>
            </div>
        </div>          

        <Answer :checkCorrect="checkCorrect" :star="star" :resetGame="resetGame" :nextCheckPoint="nextCheckPoint" /> 
    </div>    
    <HowTo :setShowContent="setShowContent" :checkpoint='2'/>    
</template>

<script>
import HowTo from "../components/HowTo.vue";
import Sound from "../components/Sound.vue";
import Answer from "../components/Answer.vue";
import actionUpdateCheckpoint from '../js/firebase-action';
import logPlay from '../js/logs-play';
import soundAnswer from "../js/sound-answer";

const path = '../assets/checkpoint/2';

export default {
    name: "CheckPointBathroom",    
    components: {
        HowTo,        
        Sound,
        Answer
    },
    data(){
        return {
            blur: true,    
            checkCorrect: '',
            answer: [],
            star: 0,      
            countGameOver: 0,      
            levels: {
                easy: [
                    {
                        id: 1,
                        url: `${path}/soap.png`,
                        name: 'soap',
                        check: true,
                    },
                    {
                        id: 2,
                        url: `${path}/spoon.png`,
                        name: 'spoon',
                        check: false,
                    },{
                        id: 3,
                        url: `${path}/chair.png`,
                        name: 'chair',
                        check: false,
                    }
                ],
                medium: [
                    {
                        id: 1,
                        url: `${path}/soap.png`,
                        name: 'soap',
                        check: true,
                    },
                    {
                        id: 2,
                        url: `${path}/fork.png`,
                        name: 'fork',
                        check: false,
                    },
                    {
                        id: 3,
                        url: `${path}/toothbrush.png`,
                        name: 'toothbrush',
                        check: true,
                    },
                    {
                        id: 4,
                        url: `${path}/glove.png`,
                        name: 'glove',
                        check: false,
                    },
                    {
                        id: 5,
                        url: `${path}/toothpaste.png`,
                        name: 'toothpaste',
                        check: true,
                    },  
                ],
                hard: [
                    {
                        id: 1,
                        url: `${path}/soap.png`,
                        name: 'soap',
                        check: true,
                    },
                    {
                        id: 2,
                        url: `${path}/plate.png`,
                        name: 'plate',
                        check: false,
                    },
                    {
                        id: 3,
                        url: `${path}/toothbrush.png`,
                        name: 'toothbrush',
                        check: true,
                    },
                    {
                        id: 4,
                        url: `${path}/toothpaste.png`,
                        name: 'toothpaste',
                        check: true,
                    },
                    {
                        id: 5,
                        url: `${path}/fan.png`,
                        name: 'fan',
                        check: false,
                    },      
                ]
            }
        };        
    },
    created () {
        !this.$store.state.user_id ? window.location.replace("/#/logout/") : '';         
    },
    methods: {
        setShowContent() {
            this.blur = false;           
        },
        setShowModalCorrect() {
            // this.blur = true;
            this.checkCorrect = 'correct';
        },
        setShowModalInCorrect() {
            // this.blur = true;
            this.checkCorrect = 'incorrect';
        },
        checkGameOver() {            
            console.log('Count Game Over'+ this.countGameOver);
            this.countGameOver += 1;
            if(this.countGameOver >= 3){                
                this.star = 1;
                this.updateCheckpointStarInFirebase();
                this.setShowModalInCorrect();        
                this.countGameOver = 0;                                        
            }else{
                this.resetGame();
            }            
        },
        clearCheckBox() {
            const parseAnswer = JSON.parse(JSON.stringify(this.answer));            
            parseAnswer.map((item) => {
                document.getElementById(item.id).removeAttribute("checked")
            });
        },
        checkAnswer(mode) {          

            const parseAnswer = JSON.parse(JSON.stringify(this.answer));            

            if(this.answer.length < (mode === 'easy' ? 1 : 3) ){
                alert('Please select a answer');
                return;
            }        
            
            if(parseAnswer.filter(item => item.check === false).length > 0){
                this.checkGameOver();                
                this.clearCheckBox();
                this.answer = [];
                soundAnswer('incorrect');
            }else{
                this.star = this.countGameOver === 2 ? 2 : 3;
                this.countGameOver = 0; 
                this.clearCheckBox();  
                this.updateCheckpointStarInFirebase();
                this.setShowModalCorrect();
                this.answer = [];                              
                soundAnswer('correct');
            }            
        },
        resetGame(){
            this.clearCheckBox();            
            this.blur = false;
            this.checkCorrect = '';                        
        },
        nextCheckPoint (){            

            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level];
            const my_checkpoint = 2;
            const checkpoint_index = [1, 2, 3, 4, 5, 6];

            const next = checkpoint_index.filter((i) => {
                const star = starByCheckpoint[`checkpoint_${i}`];
                return i > my_checkpoint && star < 3 ? i : '';                
            });

            window.location.replace(`/#/checkpoint/${next.length > 0 ? next[0]: ''}`);
        },
        checked(id, check, mode) {
            console.log({
                id, check, mode
            });
            const parseAnswer = JSON.parse(JSON.stringify(this.answer));

            console.log(this.answer.length);
            console.log('id: ' + id + ', check: ' + check);                      
            
            const checkbox = document.getElementById(id);            
            const getChecked = checkbox.getAttribute('checked');
            if(getChecked){
                checkbox.removeAttribute("checked");
                
                const filterAnswer = parseAnswer.filter(item => item.id === id);
                if(filterAnswer.length > 0){
                    this.answer = parseAnswer.filter(item => item.id !== id);
                }                

            }else{
                
                if(this.answer.length == (mode === 'easy' ? 1 : 3)){
                    alert('Maximum select answer');
                    return;
                }

                checkbox.setAttribute("checked","true");   

                this.answer = [...parseAnswer, {
                    id: id,
                    check: check
                }];
                
            }

            console.log(this.answer);
        },
        async updateCheckpointStarInFirebase() {
            const checkpoints = this.$store.state.checkpoints;
            const level = this.$store.state.level;
            const document_id = this.$store.state.user_id;
            const user = this.$store.state.user;
            const checkpointUpdate = {
                checkpoint_2: this.star
            }

            await logPlay(user, 2, this.star);

            var parseCheckpoint = JSON.parse(JSON.stringify(checkpoints));
            const starByCheckpoint = parseCheckpoint[level]['checkpoint_2'];

            if(this.star > starByCheckpoint){
                parseCheckpoint[level]['checkpoint_2'] = this.star;
                await actionUpdateCheckpoint(document_id, level, checkpoints, checkpointUpdate);
                this.$store.dispatch('setCheckPoint', parseCheckpoint);
            }
        }
    }
};
</script>